import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = comics
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">千万读者的一致选择</p>
          </div>
          <Link
            to="/category/action"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画网热门推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {comic.status === 'ongoing' ? '连载' : '完结'}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <div className="flex items-center gap-1 text-white/90 text-xs">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 truncate">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}